import { Note, Person } from "../../../types/person";
import { deleteNote, listNotesPerson } from "../../../services/person";
import { useMutation, useQuery } from "react-query";
import { Table } from "../../../components/Table";
import Paper from "@mui/material/Paper";
import { useStyles } from "../styles";
import { format } from "date-fns";
import { useCallback, useState } from "react";
import Stack from "@mui/material/Stack";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import { Delete, Edit } from "@mui/icons-material";
import { EditNote } from "../EditNote";
import { useDialogConfirmation } from "../../../hooks/useDialogConfirmation";
import { queryClient } from "../../../services/queryClient";
import { useToast } from "../../../hooks/useToast";

type NotesProps = {
  person: Person;
};

export function Notes({ person }: NotesProps) {
  const styles = useStyles();
  const [note, setNote] = useState();
  const [dialogEditNote, setDialogEditNote] = useState<boolean>(false);

  const dialog = useDialogConfirmation();
  const toast = useToast();

  const notes = useQuery(["notes", person?.id_pessoa], () =>
    listNotesPerson(person?.id_pessoa)
  );

  const removeNote = useMutation(
    async (item: Note) => {
      const requestData = {
        deletado: 1,
        id: item.id,
        id_pessoa: item.id_pessoa,
      };
      const response = await deleteNote(requestData);
      return response;
    },
    {
      onSuccess: () => {
        toast.show("Nota excluída com sucesso!", { severity: "success" });
        queryClient.invalidateQueries(["notes"]);
        dialog.close();
      },
      onError: () => {
        toast.show("Erro ao excluir a nota!", { severity: "error" });
      },
    }
  );

  const handleDialogEditNote = useCallback((item) => {
    setNote(item);
    setDialogEditNote((prev) => !prev);
  }, []);

  const handleDeleteNote = useCallback(
    (item: Note) => {
      dialog.show("Aviso", "Deseja realmente excluir essa nota ?", {
        onConfirmate: async () => {
          await removeNote.mutateAsync(item);
        },
      });
    },
    [dialog, removeNote]
  );

  const RenderActions = useCallback(
    (item: Note) => {
      return (
        <Stack spacing={1} direction="row">
          <Tooltip
            onClick={() => handleDialogEditNote(item)}
            title="Editar"
            placement="top"
          >
            <IconButton>
              <Edit />
            </IconButton>
          </Tooltip>
          <Tooltip
            onClick={() => handleDeleteNote(item)}
            title="Deletar"
            placement="top"
          >
            <IconButton>
              <Delete />
            </IconButton>
          </Tooltip>
        </Stack>
      );
    },
    [handleDialogEditNote, handleDeleteNote]
  );

  return (
    <>
      <Paper
        variant="outlined"
        elevation={0}
        className={styles.paperWithoutWidth}
      >
        <Table
          toolbar={false}
          data={notes.data as []}
          isLoading={notes.isFetching}
          columns={[
            { title: "#ID", field: "id" },
            { title: "Nota", field: "nota" },
            {
              title: "Data",
              field: "data_insert",
              render: (row) =>
                format(
                  new Date(row?.data_insert?.replace("Z", "")),
                  "dd/MM/yyyy HH:mm"
                ),
            },
            { title: "Ações", field: "nota", render: RenderActions },
          ]}
          options={{
            actionsColumnIndex: -1,
            pageSize: 7,
            selectionProps: () => ({
              color: "primary",
            }),
          }}
          style={{ backgroundColor: "transparent" }}
          headerStyle={{ backgroundColor: "transparent" }}
        />
      </Paper>
      <EditNote
        note={note}
        person={person}
        open={dialogEditNote}
        onClose={() => handleDialogEditNote(null)}
      />
    </>
  );
}
